import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import {
    TOWN_NOT_FOUND_STATUS,
    UNABLE_TO_CANCEL_FINE_STATUS,
    PARKING_NOT_FOUND_STATUS,
    ALREADY_CANCELLED_FINE_STATUS,
    OUT_OF_DATE_FINE_STATUS,
    NON_CANCELLABLE_FINE_STATUS,
    FINE_NOT_FOUND_STATUS,
} from '../../api/status'
import messages from './messages'

const errorMap = {
    [TOWN_NOT_FOUND_STATUS]: messages.fineNonCancellableError,
    [UNABLE_TO_CANCEL_FINE_STATUS]: messages.fineNonCancellableError,
    [NON_CANCELLABLE_FINE_STATUS]: messages.fineNonCancellableError,
    [FINE_NOT_FOUND_STATUS]: messages.fineNonCancellableError,
    [PARKING_NOT_FOUND_STATUS]: messages.fineNonCancellableError,
    [ALREADY_CANCELLED_FINE_STATUS]: messages.fineAlreadyCancelledError,
    [OUT_OF_DATE_FINE_STATUS]: messages.fineOutOfDatesError,
}

const getErrorMessage = (status) => errorMap[status]

const ErrorMessage = ({ error }) => {
    const message = error && getErrorMessage(error.status)

    if (!message) {
        return <FormattedMessage {...messages.unknownError} />
    }

    return <FormattedMessage {...message} />
}

ErrorMessage.propTypes = {
    error: PropTypes.shape({
        status: PropTypes.number.isRequired,
    }).isRequired,
}

export default ErrorMessage
